module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-2.5fdfa258.jpg";